export const USER_ROLES = ["user", "admin"] as const;
export type UserRoleValue = (typeof USER_ROLES)[number];

export const ROLE_LABELS: Record<UserRoleValue, string> = {
  user: "User",
  admin: "Admin",
};

export const ALL_ACCESS = "*";

export const ACCESS_LABELS = { [ALL_ACCESS]: "All access" };

export function applyAllAccessExclusive(next: string[], prev: string[]): string[] {
  const hadAll = prev.includes(ALL_ACCESS);
  const hasAll = next.includes(ALL_ACCESS);
  if (hasAll && !hadAll) return [ALL_ACCESS];
  if (hasAll && next.length > 1) return next.filter((v) => v !== ALL_ACCESS);
  return next;
}
